/* KAELA — bannière d'accueil : fondu entre les photos, saisissable à la souris/au doigt */
(function () {
  "use strict";

  /* Distance minimale, en fraction de la largeur, pour valider un changement de
     volet. En dessous, le fondu revient en arriere : un clic qui derape de 3 px
     ne doit pas faire tourner le carrousel. */
  var THRESHOLD = 0.18;
  /* Au-dela de cette vitesse (px/ms), le geste compte meme s il est court —
     c est le coup de pouce rapide, celui qu on fait sans y penser. */
  var FLICK = 0.45;
  /* Deplacement au-dela duquel on considere que l utilisateur a glisse et non
     clique : le lien du bouton ne doit pas s ouvrir au relachement. */
  var DRAG_SLOP = 8;
  /* Le fondu suit le doigt un peu plus vite que lui : a mi-parcours l image
     suivante est deja bien la, le geste parait reactif au lieu de mou. */
  var FADE_GAIN = 1.6;
  /* Doit rester >= a la transition d opacite de .hero__slide.is-active. */
  var FADE_MS = 760;

  function init() {
    var roots = document.querySelectorAll("[data-hero]");
    for (var i = 0; i < roots.length; i++) setup(roots[i]);
  }

  function setup(root) {
    var viewport = root.querySelector("[data-hero-viewport]");
    var track = root.querySelector("[data-hero-track]");
    if (!viewport || !track) return;

    var slides = track.querySelectorAll("[data-hero-slide]");
    var captions = root.querySelectorAll("[data-hero-caption]");
    var dots = root.querySelectorAll("[data-hero-dot]");
    if (slides.length < 2) return;

    var reduced = window.matchMedia("(prefers-reduced-motion: reduce)");
    var delay = parseInt(root.getAttribute("data-delay"), 10) || 6000;
    var wantsAutoplay = root.getAttribute("data-autoplay") === "true";

    var index = 0;
    var timer = null;
    var leavingTimer = null;
    var dragging = false;
    var pointerId = null;
    var startX = 0;
    var startY = 0;
    var lastX = 0;
    var lastT = 0;
    var velocity = 0;
    var moved = 0;
    var axis = null;   // 'x' = le carrousel prend la main, 'y' = la page defile
    var preview = -1;  // volet qui monte sous le doigt
    var pointerKind = "";  // 'mouse' = navigation au clic, tactile = glissement

    root.style.setProperty("--hero-delay", delay + "ms");

    /* ---------- Affichage ---------- */

    function clearPreview() {
      if (preview < 0) return;
      slides[preview].classList.remove("is-active");
      slides[preview].style.opacity = "";
      slides[preview].style.zIndex = "";
      preview = -1;
    }

    function paint(from) {
      /* Le volet sortant reste plein juste en dessous pendant que l entrant
         monte : sans lui, les deux passent par 0,5 et le fond transparait. */
      if (leavingTimer) {
        clearTimeout(leavingTimer);
        leavingTimer = null;
      }
      for (var i = 0; i < slides.length; i++) {
        slides[i].classList.remove("is-leaving");
        slides[i].style.opacity = "";
        slides[i].style.zIndex = "";
        slides[i].classList.toggle("is-active", i === index);
        if (i === index) slides[i].removeAttribute("aria-hidden");
        else slides[i].setAttribute("aria-hidden", "true");
      }
      if (from !== undefined && from !== index && slides[from]) {
        slides[from].classList.add("is-leaving");
        leavingTimer = setTimeout(function () {
          slides[from].classList.remove("is-leaving");
          leavingTimer = null;
        }, FADE_MS);
      }

      /* Le texte ne glisse pas : il se relaie sur place. Celui qui sort est
         retire du champ et de la tabulation, sinon on tabulerait vers un
         bouton invisible. */
      for (var c = 0; c < captions.length; c++) {
        /* Bannière à texte unique : la seule legende reste affichee quel que
           soit le visuel en cours. Sans ce cas, passer au 2e volet lui
           retirerait `is-active` et le message disparaitrait. */
        var on = captions.length === 1 ? true : c === index;
        captions[c].classList.toggle("is-active", on);
        if (on) captions[c].removeAttribute("aria-hidden");
        else captions[c].setAttribute("aria-hidden", "true");

        var focusables = captions[c].querySelectorAll("a, button");
        for (var f = 0; f < focusables.length; f++) {
          if (on) focusables[f].removeAttribute("tabindex");
          else focusables[f].setAttribute("tabindex", "-1");
        }
      }

      for (var d = 0; d < dots.length; d++) {
        var active = d === index;
        dots[d].classList.toggle("is-active", active);
        if (active) dots[d].setAttribute("aria-current", "true");
        else dots[d].removeAttribute("aria-current");
      }
    }

    function goTo(next) {
      var from = index;
      clearPreview();
      index = (next + slides.length) % slides.length;
      /* Filet : si l on demande un volet avant le temps mort (clic sur une
         puce, fleche du clavier), sa photo est posee ici plutot que de
         laisser un fondu vers du vide. */
      hydrate(slides[index]);
      paint(from);
      restart();
    }

    /* ---------- Minuteur ----------
       Redemarre l animation de remplissage de la puce a chaque volet : elle
       sert de compte a rebours visible. Retirer puis remettre la classe force
       le navigateur a rejouer l animation. */

    function stop() {
      if (timer) {
        clearTimeout(timer);
        timer = null;
      }
      for (var d = 0; d < dots.length; d++) dots[d].classList.remove("is-counting");
    }

    function restart() {
      stop();
      if (!wantsAutoplay || reduced.matches || document.hidden) return;

      var dot = dots[index];
      if (dot) {
        void dot.offsetWidth; // force le redemarrage de l animation
        dot.classList.add("is-counting");
      }
      timer = setTimeout(function () {
        goTo(index + 1);
      }, delay);
    }

    /* ---------- Glissement ----------
       Le geste ne deplace rien : il dose le fondu. Vers la gauche, le volet
       suivant monte en opacite sous le doigt ; vers la droite, le precedent. */

    function onDown(e) {
      if (e.button !== undefined && e.button !== 0) return;
      /* A la souris, la banniere ne se glisse plus : elle se pilote au clic,
         moitie gauche ou moitie droite. On retient tout de meme le type de
         pointeur, c est lui qui autorise ensuite la navigation au clic — un
         tapotement au doigt ne doit pas faire tourner le carrousel. */
      pointerKind = e.pointerType || "mouse";
      if (pointerKind === "mouse") return;
      /* Le geste peut reveler le volet precedent comme le suivant : on ne sait
         pas encore lequel, donc on pose toutes les photos des le contact. */
      hydrateAll();
      dragging = true;
      pointerId = e.pointerId;
      startX = lastX = e.clientX;
      startY = e.clientY;
      lastT = e.timeStamp;
      velocity = 0;
      moved = 0;
      axis = null;
      stop();
      viewport.classList.add("is-dragging");
      /* La capture garde le geste meme si le curseur sort de la banniere.
         Elle leve si le pointeur n est plus actif : ce n est pas une raison
         pour interrompre le glissement, qui fonctionne tres bien sans. */
      if (viewport.setPointerCapture && pointerId !== undefined) {
        try { viewport.setPointerCapture(pointerId); } catch (err) {}
      }
    }

    function onMove(e) {
      if (!dragging) return;

      var dx = e.clientX - startX;
      var dy = e.clientY - startY;

      /* Premier mouvement significatif : on decide qui prend le geste. S il est
         vertical, on lache tout et la page defile normalement. */
      if (axis === null && (Math.abs(dx) > 6 || Math.abs(dy) > 6)) {
        axis = Math.abs(dx) > Math.abs(dy) ? "x" : "y";
        if (axis === "y") {
          release(false);
          return;
        }
      }
      if (axis !== "x") return;

      var dt = e.timeStamp - lastT;
      if (dt > 0) velocity = (e.clientX - lastX) / dt;
      lastX = e.clientX;
      lastT = e.timeStamp;
      moved = Math.abs(dx);

      var target = dx < 0 ? index + 1 : index - 1;

      /* Rien de ce cote : on n a personne a faire apparaitre, le geste
         n a simplement pas d effet. */
      if (target < 0 || target > slides.length - 1) {
        clearPreview();
        return;
      }

      if (preview !== target) {
        clearPreview();
        preview = target;
        slides[preview].classList.add("is-active");
        slides[preview].style.zIndex = "3";
      }

      var amount = Math.min(1, (Math.abs(dx) / viewport.offsetWidth) * FADE_GAIN);
      slides[preview].style.opacity = String(amount);
    }

    function release(commit) {
      if (!dragging) return;
      dragging = false;
      viewport.classList.remove("is-dragging");
      if (viewport.releasePointerCapture && pointerId !== undefined) {
        try { viewport.releasePointerCapture(pointerId); } catch (err) {}
      }

      var dx = lastX - startX;
      var ratio = dx / viewport.offsetWidth;
      var next = index;

      if (commit && axis === "x") {
        if (ratio < -THRESHOLD || velocity < -FLICK) next = index + 1;
        else if (ratio > THRESHOLD || velocity > FLICK) next = index - 1;
      }
      next = Math.max(0, Math.min(slides.length - 1, next));

      if (next === index) {
        /* Geste abandonne : le volet entrevu redescend en fondu au lieu de
           disparaitre d un coup. */
        if (preview >= 0) {
          var ghost = slides[preview];
          ghost.style.opacity = "0";
          var settled = preview;
          preview = -1;
          setTimeout(function () {
            if (settled !== index) {
              ghost.classList.remove("is-active");
              ghost.style.opacity = "";
              ghost.style.zIndex = "";
            }
          }, FADE_MS);
        }
        restart();
        return;
      }

      clearPreview();
      goTo(next);
    }

    viewport.addEventListener("pointerdown", onDown);
    viewport.addEventListener("pointermove", onMove);
    viewport.addEventListener("pointerup", function () { release(true); });
    viewport.addEventListener("pointercancel", function () { release(false); });

    /* Un glissement qui finit sur le bouton ne doit pas suivre le lien. */
    viewport.addEventListener("click", function (e) {
      if (moved > DRAG_SLOP) {
        e.preventDefault();
        e.stopPropagation();
        moved = 0;
      }
    }, true);

    /* Le navigateur propose sa propre image fantome au glisser : on la coupe. */
    viewport.addEventListener("dragstart", function (e) { e.preventDefault(); });

    /* ---------- Clic gauche / droite (ordinateur) ----------
       Sur grand ecran, cliquer dans la moitie gauche de la photo revient au
       volet precedent, la moitie droite avance. Au doigt on garde le
       glissement : un tapotement y sert a ouvrir, pas a naviguer.

       Le bouton et les puces vivent hors du viewport, leurs clics ne
       remontent donc pas jusqu ici. Restent les clics qui traversent le
       calque de texte (il est en pointer-events: none) : ceux-la tombent
       dans la moitie gauche, ce qui est le comportement attendu. */
    function sideOf(clientX) {
      var r = viewport.getBoundingClientRect();
      return clientX - r.left < r.width / 2 ? "left" : "right";
    }

    viewport.addEventListener("click", function (e) {
      /* Reserve a la souris : au doigt, un tapotement ne doit pas naviguer,
         c est le glissement qui commande. */
      if (pointerKind !== "mouse") return;
      if (moved > DRAG_SLOP) return;
      if (e.target.closest("a, button")) return;
      goTo(sideOf(e.clientX) === "left" ? index - 1 : index + 1);
    });


    /* ---------- Puces, clavier, pauses ---------- */

    for (var d = 0; d < dots.length; d++) {
      (function (i) {
        dots[i].addEventListener("click", function () { goTo(i); });
      })(d);
    }

    root.addEventListener("keydown", function (e) {
      if (e.key === "ArrowLeft") { goTo(index - 1); e.preventDefault(); }
      else if (e.key === "ArrowRight") { goTo(index + 1); e.preventDefault(); }
    });

    /* Pendant la lecture ou la navigation au clavier, le minuteur se tait. */
    root.addEventListener("mouseenter", stop);
    root.addEventListener("mouseleave", restart);
    root.addEventListener("focusin", stop);
    root.addEventListener("focusout", function (e) {
      if (!root.contains(e.relatedTarget)) restart();
    });

    /* Onglet en arriere-plan : inutile de compter dans le vide. */
    document.addEventListener("visibilitychange", function () {
      if (document.hidden) stop();
      else restart();
    });

    if (reduced.addEventListener) {
      reduced.addEventListener("change", restart);
    }

    /* L editeur de theme selectionne un bloc sans recharger la page. */
    document.addEventListener("shopify:block:select", function (e) {
      var slide = e.target.closest ? e.target.closest("[data-hero-slide]") : null;
      if (!slide || !root.contains(slide)) return;
      for (var i = 0; i < slides.length; i++) {
        if (slides[i] === slide) goTo(i);
      }
      stop();
    });

    /* ---------- Arrivee differee des volets 2 a n ----------
       Ces volets partent SANS adresse (`data-src` / `data-srcset`, voir
       `hero-slide.liquid`). Raison : ils sont empiles en `position: absolute`
       au meme endroit que le premier, donc tous dans la fenetre — pour le
       navigateur ils sont visibles, et `loading="lazy"` ne differait rien du
       tout. Mesure du 29/08/2026 : les huit fichiers du carrousel arrivaient
       au chargement, dont 580 Ko de cadrages larges qu un telephone n affiche
       jamais.

       On pose donc les adresses nous-memes, une fois la page au calme. Le
       <source> passe AVANT l <img> : c est lui qui decide sur grand ecran, et
       le navigateur choisit a la premiere adresse posee. */
    function hydrate(slide) {
      if (!slide) return;
      var pic = slide.querySelector("[data-hero-deferred]");
      if (!pic) return;
      pic.removeAttribute("data-hero-deferred");

      var sources = pic.querySelectorAll("source[data-srcset]");
      for (var s = 0; s < sources.length; s++) {
        sources[s].srcset = sources[s].getAttribute("data-srcset");
        sources[s].removeAttribute("data-srcset");
      }
      var img = pic.querySelector("img[data-src]");
      if (img) {
        img.src = img.getAttribute("data-src");
        img.removeAttribute("data-src");
        img.removeAttribute("loading");
      }
    }

    function hydrateAll() {
      for (var i = 0; i < slides.length; i++) hydrate(slides[i]);
    }

    /* Apres le chargement et un temps mort : la premiere image, elle, ne doit
       partager la bande passante avec personne. Le `timeout` garantit qu on
       n attend pas indefiniment un navigateur toujours occupe — l autoplay
       change de volet a 6 s, il faut etre pret bien avant. */
    function scheduleHydration() {
      if (window.requestIdleCallback) {
        window.requestIdleCallback(hydrateAll, { timeout: 2500 });
      } else {
        setTimeout(hydrateAll, 1200);
      }
    }

    if (document.readyState === "complete") scheduleHydration();
    else window.addEventListener("load", scheduleHydration);

    paint();
    restart();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
